import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../../../store/store';

// 首页
import routeHome from './home';

// 应用中心
import routeAppCenter from './appCenter';

// 基础文档
import routeBasicDoc from './basicDoc';

// 服务能力
import routeServicePower from './servicePower';

// 个人中心
import routePersonalCenter from './personalCenter';

// 用户设置
import routeUserSetting from './userSetting';

Vue.use(VueRouter)
const createRouter = () => new VueRouter({
  // mode: 'history',
  base: process.env.NODE_ENV === 'production' ? ('/' + process.env.VUE_APP_PROJECTNAME) : '',
  routes: [
    {
      path: '*',
      name: 'not_found',
      component: () => import('@/views/index/components/notFound.vue'),
      meta: {
        unrequireLogin: true,
      }
    }, // 404
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/index/components/default.vue'),
      meta: {
        unrequireLogin: true,
      },
      redirect: {
        name: 'home'
      },
      children: [
        routeHome,
        routeAppCenter,
        routeBasicDoc,
        routeServicePower,
        routePersonalCenter,
        routeUserSetting,
        // 账号激活,忘记密码，无需权限
        {
          path: '/activeAccount',
          name: 'activeAccount',
          component: () => import('@/views/index/components/activeAccount.vue'),
          meta: {
            unrequireLogin: true
          }
        },
        {
          path: '/findPwd',
          name: 'findPwd',
          component: () => import('@/views/index/components/findPwd.vue'),
          meta: {
            unrequireLogin: true
          }
        }
      ]
    },
    // 组件开发
    {
      path: '/compDevelop',
      name: 'compDevelop',
      component: () => import('@/views/index/components/personalCenter/compManage/compManageDevelop.vue'),
      meta: {
        unrequireLogin: true,
      }
    }
  ]
})
const router = createRouter();
router.beforeEach((to, from, next) => {

  // 判断该路由是否不需要登录权限
  if (to.meta && to.meta.unrequireLogin) {
    // 不需要登陆，直接走
    next()
  } else {
    // 当没有权限的时候但没有指定path的时候，调到not-found
    if (to.path === '/' && to.name !== 'index') {
      next({path: '/not-found'})
    }
    // 需要登陆
    // 通过vuex state获取当前的token是否存在
    if (store.state.loginToken) {
      next()
    } else {
      // 说明不是原地刷新
      if (from.name) {
        store.commit('setRouteBeforeName', {
          routeBeforeName: to.name
        })
      } else {
        next({name: 'index'})
      }
    }
  }
})

router.onError(() => {
  window.location.reload();
});
export {router}